import React from "react";
import vedImage from "../Files/images/Photo_Vedanshu.jpeg";

function LeftImageNav () {
    return (
        <>
            <section className="left-nav">

                <button className="icon-only">
                    <img src={vedImage} alt="ved-img" />
                </button>
                
            </section>
        </>
    )
}

export default LeftImageNav;